import type { TableColumns } from '@ohpen/enso-ui';
import { BdmResponse, RegionResponse } from '@pmp/api';

// Rows carry resolved names for the delete-block tooltips; the linked-entity columns
// resolve ids -> names through the table's valueLists (BDMS_LIST / REGIONS_LIST).
export type RegionRow = RegionResponse & { bdmNames: string[] };
export type BdmRow = BdmResponse & { regionNames: string[] };

export const BDMS_LIST = 'bdms';
export const REGIONS_LIST = 'regions';

const labels = 'lender.regionsBdms.labels';

export const regionColumns: TableColumns<RegionRow> = [
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    key: 'name',
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.linkedBdms`,
    dataIndex: 'bdmIds',
    key: 'bdmIds',
    options: { filter: 'select', format: { type: 'multiValueList' }, listName: BDMS_LIST },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 130, fixed: 'right' },
];

export const bdmColumns: TableColumns<BdmRow> = [
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    key: 'name',
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.contactNumber`,
    dataIndex: 'contactNumber',
    key: 'contactNumber',
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.description`,
    dataIndex: 'description',
    key: 'description',
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.linkedRegions`,
    dataIndex: 'regionIds',
    key: 'regionIds',
    options: { filter: 'select', format: { type: 'multiValueList' }, listName: REGIONS_LIST },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 130, fixed: 'right' },
];
